import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/food',
    meta: {
        title: 'Healthy food | Child Poverty',
    },
    title: 'Healthy food',
    intro: oneLine`The latest available data on food insecurity found that <b>56%</b> of tamariki whose whānau receive 
        financial assistance are in households where there is not always enough healthy food on the table, compared 
        to just <b>12%</b> of tamariki whose whānau do not receive financial assistance.`,
    image: {
        filename: 'Food.png',
        alt: '',
    },
    content: [
        oneLine`<p>Whānau already struggling to meet essential living costs prior to COVID-19 faced additional 
            challenges during lockdown. Community organisations providing food parcels reported a surge in provision 
            during COVID-19. Food parcels helped whānau overcome financial and other barriers to healthy food during 
            this time.</p>`,
    ],
};

export default data;
